import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx"
import GlobalHelper from "../GlobalHelper.jsx";
const uuidv4 = require('uuid/v4')

class QuoteIdentifier extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            item: this.props.value || null,
            uniqueId: uuidv4(),
            editable: this.props.editable,
            identifierId: this.props.identifierId,
            editMode: false,
            onChange: this.props.onChange || function () { },
            className: this.props.className || '',
            fullOverride: this.props.identifier || '',
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.save = this.save.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            fullOverride: nextProps.identifier || '',
        })
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient().patch('/identifiers/' + this.state.identifierId, {
            fullOverride: this.state.fullOverride,
        }).then((r) => {
            this.setState({
                editMode: false,
            }, () => {
                this.state.onChange(r)
            })
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    render() {
        if (!this.state.editable) {
            return ''
        }

        return <div className={this.state.className}>
            <p className={'m-0'}>
                <a href={'#'} className="btn btn-outline-primary" aria-expanded="false" onClick={this.triggerEdit}>
                    <Icon value={'hashtag'} className={'mr-1'} />
                    <FormattedMessage
                        id="common.quote.change_identifier_btn"
                        defaultMessage="Change identifier"
                    />
                </a>
            </p>
            <div className={"dropdown-menu p-4 mb-3 w-100 " + (this.state.editMode ? 'show' : '')} style={{
                position: 'relative'
            }}>
                <p className="m-0 pt-2">
                    <input
                        type="text"
                        className="form-control"
                        value={this.state.fullOverride}
                        onChange={(event) => {
                            this.setState({ fullOverride: event.target.value })
                        }}
                    />
                </p>
                <p className="m-0 pt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                        <Icon value={"arrow-left"} />
                    </button>
                    <button className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                        <Icon value={"save"} />
                    </button>
                </p>
            </div>
        </div>
    }

}

export default QuoteIdentifier





// WEBPACK FOOTER //
// ./src/common/quote/identifier.component.jsx